// extracted by mini-css-extract-plugin
export default {"checkout":"DetailHistory_checkout__iMO+q","checkout-top":"DetailHistory_checkout-top__OZVjV"};